/*
Sai Maheshwar 12/14/2022 3031450488 added save close for add user

*/

export const _fileLoader = ({
  readerTypeFunction,
  documentURI,
  signal,
  headers,
  fileLoaderComplete = () => {},
}) => {
  return fetch(documentURI, {signal, headers})
    .then(async (res) => {
      const blob = await res.blob();

      const fileReader = new FileReader();
      fileReader.onloadend = fileLoaderComplete;

      switch (readerTypeFunction) {
      case 'arrayBuffer':
        fileReader.readAsArrayBuffer(blob);
        break;
      case 'binaryString':
        fileReader.readAsBinaryString(blob);
        break;
      case 'dataURL':
        fileReader.readAsDataURL(blob);
        break;
      case 'text':
        fileReader.readAsText(blob);
        break;

      default:
        break;
      }
    })
    .catch((e) => {
      return e;
    });
};

export const tempSelectFunc = (key1, key2, tempUnCheckedRef) => {
  const obj = {};
  tempUnCheckedRef.current.forEach((el) => {
    if (key1 && key2) {
      if (!obj[el[key1] + el[key2]]) {
        obj[el[key1] + el[key2]] = el;
      }
    } else {
      if (!obj[el[key1]]) {
        obj[el[key1]] = el;
      }
    }
  });
  return obj;
};

export const tempSelectFieldTypeFunc = (key1, key2, key3, tempUnCheckedRef) => {
  const obj = {};
  tempUnCheckedRef.current.forEach((el) => {
    if (key1 && key2 && key3) {
      if (!obj[el[key1] + el[key2] + el[key3]]) {
        obj[el[key1] + el[key2] + el[key3]] = el;
      }
    } else if (key1 && key2) {
      if (!obj[el[key1] + el[key2]]) {
        obj[el[key1] + el[key2]] = el;
      }
    } else {
      if (!obj[el[key1]]) {
        obj[el[key1]] = el;
      }
    }
  });
  return obj;
};
export const tempSelectFunc2 = (key1, tempUnCheckedRef) => {
  const obj = {};
  tempUnCheckedRef.current.forEach((el) => {
    if (key1) {
      if (!obj[el[key1]]) {
        obj[el[key1]] = el;
      }
    } else {
      if (!obj[el[key1]]) {
        obj[el[key1]] = el;
      }
    }
  });
  return obj;
};
export const filteredCheckedData = (orgArr, compareObj, key1, key2) => {
  let newSelectedRows = [];
  const newUnSelectedRows = [];
  if (key1 && key2) {
    newSelectedRows = orgArr?.filter((el) => {
      if (compareObj[el[key1] + el[key2]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  } else {
    newSelectedRows = orgArr.filter((el) => {
      if (compareObj[el[key1]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  }

  return [newSelectedRows, newUnSelectedRows];
};
export const filteredCheckedData2 = (orgArr, compareObj, key1) => {
  let newSelectedRows = [];
  const newUnSelectedRows = [];
  if (key1) {
    newSelectedRows = orgArr?.filter((el) => {
      if (compareObj[el[key1]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  } else {
    newSelectedRows = orgArr.filter((el) => {
      if (compareObj[el[key1]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  }

  return [newSelectedRows, newUnSelectedRows];
};
export const filteredCheckedFieldTypeData = (orgArr, compareObj, key1, key2, key3) => {
  let newSelectedRows = [];
  const newUnSelectedRows = [];

  if (key1 && key2 && key3) {
    newSelectedRows = orgArr?.filter((el) => {
      if (compareObj[el[key1] + el[key2] + el[key3]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  } else if (key1 && key2) {
    newSelectedRows = orgArr?.filter((el) => {
      if (compareObj[el[key1] + el[key2]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  } else {
    newSelectedRows = orgArr.filter((el) => {
      if (compareObj[el[key1]]) {
        newUnSelectedRows.push(el);
        return false;
      } else {
        return true;
      }
    });
  }

  return [newSelectedRows, newUnSelectedRows];
};

export function getSesssionData(key) {
  let sessionData = sessionStorage.getItem(key) || JSON.stringify({});
  try {
    sessionData = JSON.parse(sessionData);
  } catch (err) {
    sessionData = {};
  }
  return sessionData;
}